import { useCustomTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'
import { AffectedAssetsTable } from '@ui/drawer/common/AffectedAssetsTable'
import { IssueDrawerLayout } from '@ui/drawer/common/IssueDrawerLayout'
import { IssueDrawerFooter } from '@ui/drawer/common/IssueDrawerFooter'
import { RemediationStepsCard } from '@ui/drawer/common/RemediationStepsCard'
import { useIssueDetails } from './useIssueDetails'
import {
    InlineListRow,
    InlineListLabel,
    StackedListRow,
} from './IssueDetails.styles'

const IssueDetails = () => {
    const theme = useCustomTheme()
    const {
        issue,
        enrichedRows,
        columns,
        selectedIds,
        setSelectedIds,
        resolution,
        selection,
        selectionDisabled,
        assetsTestIdPrefix,
    } = useIssueDetails()

    const footer = issue.status === 'open' && (
        <IssueDrawerFooter
            resolution={resolution}
            selectedCount={selectedIds.length}
            hasSelectableAssets={enrichedRows.length > 0}
            selection={selection}
        />
    )

    return (
        <IssueDrawerLayout footer={footer}>
            <Typography
                variant="s-regular"
                noWrap={false}
                color={theme.colors.greys[800]}
                whiteSpaceRule="pre-line"
                testId="short-description"
            >
                {issue.short_description}
            </Typography>
            {issue.issue_type === 'GENERAL' &&
                issue.ports &&
                issue.ports.length > 0 && (
                    <InlineListRow data-testid="issue-ports">
                        <InlineListLabel
                            variant="xs-bold"
                            color={theme.colors.greys[800]}
                        >
                            {issue.ports.length > 1 ? 'Ports' : 'Port'}:
                        </InlineListLabel>
                        <Typography
                            variant="xs-regular"
                            color={theme.colors.greys[800]}
                        >
                            {issue.ports.join(', ')}
                        </Typography>
                    </InlineListRow>
                )}
            {(issue.issue_type === 'GENERAL' ||
                issue.issue_type === 'CLOUD_APP') &&
                issue.email_addresses &&
                issue.email_addresses.length > 0 && (
                    <StackedListRow data-testid="issue-email-addresses">
                        <InlineListLabel
                            variant="xs-bold"
                            color={theme.colors.greys[800]}
                        >
                            {issue.email_addresses.length > 1
                                ? 'Email Addresses'
                                : 'Email Address'}
                            :
                        </InlineListLabel>
                        <Typography
                            variant="s-regular"
                            noWrap={false}
                            color={theme.colors.greys[800]}
                        >
                            {issue.email_addresses.join(' | ')}
                        </Typography>
                    </StackedListRow>
                )}
            {issue.issue_type === 'GENERAL' &&
                issue.hosts &&
                issue.hosts.length > 0 && (
                    <InlineListRow data-testid="issue-hosts">
                        <InlineListLabel
                            variant="xs-bold"
                            color={theme.colors.greys[800]}
                        >
                            {issue.hosts.length > 1 ? 'Hosts' : 'Host'}:
                        </InlineListLabel>
                        <Typography
                            variant="xs-regular"
                            noWrap={false}
                            color={theme.colors.greys[800]}
                        >
                            {issue.hosts.join(', ')}
                        </Typography>
                    </InlineListRow>
                )}
            <RemediationStepsCard issue={issue} />
            <AffectedAssetsTable
                testIdPrefix={assetsTestIdPrefix}
                rows={enrichedRows}
                columns={columns}
                selectedIds={selectedIds}
                onSelectionChange={setSelectedIds}
                disabled={selectionDisabled}
                searchable
                searchKeys={['hostname']}
            />
        </IssueDrawerLayout>
    )
}

export default IssueDetails
